import { useMemo } from "react";

import { LABELLING } from "../config/labelling";
import { useRegionalBackend } from "../context/RegionalBackendContext";
import { resolveProductPresentationLabelling } from "../utils/productPresentation/labelling";

export function usePresentationLabelling(surfaceKey = "userWebApp") {
  const { productPresentationProfile } = useRegionalBackend();

  return useMemo(
    () =>
      resolveProductPresentationLabelling(productPresentationProfile, {
        surfaceKey,
        fallbackProfileId: LABELLING.PRODUCT_PRESENTATION_PROFILE_ID,
        fallbackAppName: LABELLING.APP_NAME,
      }),
    [productPresentationProfile, surfaceKey],
  );
}
